module.exports = __webpack_public_path__ + "img/logo-frontier.35e4aa58.svg";